export default __webpack_public_path__ + "static/media/Walker's Bracers of the Four Winds.7ca341de.jpg";